export default [
    {
        path: '/paypal',
        name: 'paypal',
        meta: {
            name: 'paypal设置',
            keepAlive: true
        },
        component: () => import(/* webpackChunkName: "setting" */ '@/views/paypal/setting/index.vue')
    },
    {
        path: '/paypal-monitor',
        name: 'paypal-monitor',
        meta: {
            name: 'paypal监控中心',
            keepAlive: true,
            notLayout: true
        },
        component: () => import(/* webpackChunkName: "setting" */ '@/views/paypal/paypal-monitor/index.vue')
    }
]
